import { useContext, useMemo } from 'react';
import AppContext from '../../AppContext';
import UnsafeHtml from '../common/UnsafeHtml';
import Preis from '../common/Preis';
import { getBreite,
  getHoehe,
  getLaenge,
  getNullableSelectedVariationWert,
  getSelectedVariationWert,
  getTiefe,
  getWandschienenhoehe } from '../../utils/app-data';
import decodeHTML from '../../utils/html';
import { calculatePrice } from '../../utils/price';

function Konfiguration() {
  const { appData } = useContext(AppContext);

  let breite = 0;
  let hoehe = 0;
  let laenge = 0;
  let tiefe = 0;
  let versand;
  let priceVersand;
  const wandschienenhoehe = useMemo(() => getWandschienenhoehe(appData), [appData]);
  if (appData.static.kEigenschaftVersand) {
    versand = getSelectedVariationWert(appData.static.artikel, appData.dynamic.selectedVariationWerte, appData.static.kEigenschaftVersand);
    [priceVersand] = versand.fAufpreis;
  }
  let faktor: number;
  if (appData.static.config.productType === 'rolladen') {
    breite = getBreite(appData);
    hoehe = getHoehe(appData);
    faktor = (breite * hoehe) / 1_000_000;

    // Mindestabnahme: 1 qm
    faktor = Math.max(faktor, 1);
  } else if (appData.static.config.productType === 'stahlwelle'
    || appData.static.config.productType === 'lamelle'
    || appData.static.config.productType === 'fuehrungsschiene'
    || appData.static.config.productType === 'endleiste'
    || appData.static.config.productType === 'deckleiste') {
    laenge = getLaenge(appData);
    faktor = laenge / 1_000;
  } else if (appData.static.config.productType === 'hochwasserschutz') {
    breite = getBreite(appData);
    faktor = 1;
  } else if (appData.static.config.productType === 'insektenschutz') {
    breite = getBreite(appData);
    tiefe = getTiefe(appData);
    faktor = 0;
  } else {
    throw Error(`Unknown product type: ${appData.static.config.productType}`);
  }

  const verstaerkung = getNullableSelectedVariationWert(
    appData.static.artikel,
    appData.dynamic.selectedVariationWerte,
    appData.static.kEigenschaftVerstaerkung
  );

  return (
    <div className="configurator__konfiguration">
      <h3 className="mt-5">Ihre Konfiguration</h3>
      <hr />
      <div className="mt-3">
        <div className="row mt-1 font-weight-bold">
          <div className="col-5">Option</div>
          <div className="col-4">Auswahl</div>
          <div className="col-3 text-right">Betrag</div>
        </div>
        {appData.static.config.productType === 'rolladen'
          && (
            <div className="row">
              <div className="col-5">Breite x Höhe</div>
              <div className="col-4">
                {`${breite} x ${hoehe} (mm)`}
              </div>
              <div className="col-3 text-right">
                <Preis value={appData.static.artikel.preise.fVKBrutto * faktor} />
              </div>
            </div>
          )}
        {(appData.static.config.productType === 'stahlwelle'
          || appData.static.config.productType === 'lamelle'
          || appData.static.config.productType === 'fuehrungsschiene')
          && (
            <div className="row">
              <div className="col-5">Länge</div>
              <div className="col-4">
                {`${laenge} (mm)`}
              </div>
              <div className="col-3 text-right">
                <Preis value={appData.static.artikel.preise.fVKBrutto * faktor} />
              </div>
            </div>
          )}
        {appData.static.config.productType === 'insektenschutz'
          && (
            <div className="row">
              <div className="col-5">Breite x Tiefe</div>
              <div className="col-4">
                {`${breite} x ${tiefe} (mm)`}
              </div>
              <div className="col-3 text-right">
                <Preis value={calculatePrice(appData.static.priceTableNetto, tiefe, breite, Number(appData.static.artikel.preise.fUst))} />
              </div>
            </div>
          )}
        {appData.static.config.productType === 'hochwasserschutz'
          && (
            <div>
              <div className="row">
                <div className="col-5">Montageart</div>
                <div className="col-7">
                  <UnsafeHtml unsafeHtml={getSelectedVariationWert(
                    appData.static.artikel,
                    appData.dynamic.selectedVariationWerte,
                    appData.static.kEigenschaftMontageart
                  ).cName}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-5">Systembreite</div>
                <div className="col-7">
                  {`${breite} mm`}
                </div>
              </div>
              <div className="row">
                <div className="col-5">Stauhöhe</div>
                <div className="col-7">
                  <UnsafeHtml unsafeHtml={getSelectedVariationWert(
                    appData.static.artikel,
                    appData.dynamic.selectedVariationWerte,
                    appData.static.kEigenschaftStauhoehe
                  ).cName}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-5">Wandschienenhöhe</div>
                <div className="col-7">
                  {`${wandschienenhoehe} mm`}
                </div>
              </div>
            </div>
          )}
        {appData.static.config.productType !== 'hochwasserschutz'
          && appData.static.artikel.variationen
          && Object.values(appData.static.artikel.variationen)
            .map((variation) => (
              variation.kEigenschaft !== appData.static.kEigenschaftBreite
              && variation.kEigenschaft !== appData.static.kEigenschaftHoehe
              && variation.kEigenschaft !== appData.static.kEigenschaftVersand
              && variation.kEigenschaft !== appData.static.kEigenschaftLaenge
              && variation.kEigenschaft !== appData.static.kEigenschaftTiefe
              && (
                <div key={variation.kEigenschaft} className="row">
                  <div className="col-5">{decodeHTML(variation.cName)}</div>
                  <div className="col-4">
                    {!(variation.cTyp === 'FREIFELD' || variation.cTyp === 'PFLICHT-FREIFELD')
                      && (
                        <UnsafeHtml unsafeHtml={getSelectedVariationWert(
                          appData.static.artikel,
                          appData.dynamic.selectedVariationWerte,
                          variation.kEigenschaft
                        ).cName}
                        />
                      )}
                    {(variation.cTyp === 'FREIFELD' || variation.cTyp === 'PFLICHT-FREIFELD')
                      && (
                        <span>{appData.dynamic.selectedVariationWerte[variation.kEigenschaft]}</span>
                      )}
                  </div>
                  <div className="col-3 text-right">
                    <Preis value={getSelectedVariationWert(
                      appData.static.artikel,
                      appData.dynamic.selectedVariationWerte,
                      variation.kEigenschaft
                    ).fAufpreis[0] * faktor}
                    />
                  </div>
                </div>
              )))}
        {appData.static.config.productType === 'hochwasserschutz' && verstaerkung
          && (
            <div className="row">
              <div className="col-5">Verstärkung</div>
              <div className="col-4">
                <UnsafeHtml unsafeHtml={verstaerkung.cName} />
              </div>
              <div className="col-3 text-right">
                <Preis value={verstaerkung.fAufpreis[0]} />
              </div>
            </div>
          )}
        {versand && priceVersand != null
          && (
            <div className="row">
              <div className="col-5">Versandkostenzuschlag</div>
              <div className="col-4">
                {decodeHTML(versand.cName)}
              </div>
              <div className="col-3 text-right">
                <Preis value={priceVersand} />
              </div>
            </div>
          )}
      </div>
    </div>
  );
}

export default Konfiguration;
